
import { LIMPAR_CONFIGURACAO_PONTO_EMPRESA } from '../types'

export default function limparConfiguracaoPontoEmpresa () {
  return {
    type: LIMPAR_CONFIGURACAO_PONTO_EMPRESA
  }
}

